/**
 * Como um tema é classificado (`theme.classification_mode`) e, no modo
 * "determinístico e IA", em que fonte o termo vale (`theme.deterministic_scope`).
 *
 * Espelho de `core.vocabulary.THEME_CLASSIFICATION_MODES` e
 * `DETERMINISTIC_SCOPES` (o `core/` é o dono; paridade por FONTE em
 * `tests/test_theme_classification_parity.py`).
 */
export const THEME_CLASSIFICATION_MODES = ["deterministic", "ai", "both"] as const;

export type ThemeClassificationMode = (typeof THEME_CLASSIFICATION_MODES)[number];

export const THEME_CLASSIFICATION_MODE_LABELS: Record<ThemeClassificationMode, string> = {
  deterministic: "Só determinístico",
  ai: "Só IA",
  both: "Determinístico e IA"
};

export const DETERMINISTIC_SCOPES = ["press", "network", "both"] as const;

export type DeterministicScope = (typeof DETERMINISTIC_SCOPES)[number];

export const DETERMINISTIC_SCOPE_LABELS: Record<DeterministicScope, string> = {
  press: "Imprensa",
  network: "Redes",
  both: "Imprensa e redes"
};

/** O rótulo curto que a lista de temas mostra ao lado do nome; vazio no
 * caso comum (termo e IA nas duas fontes). */
export function themeModeTag(mode: ThemeClassificationMode, scope: DeterministicScope): string {
  if (mode === "deterministic") return "só determinístico";
  if (mode === "ai") return "só IA";
  if (scope === "both") return "";
  return `determinístico só em ${DETERMINISTIC_SCOPE_LABELS[scope].toLowerCase()}`;
}
